import { ETypeParking, ILocation } from '../models';

export const isResidenceLocation = (location: ILocation): boolean => {
  return location.typeParking === ETypeParking.RESIDENCE;
};
